import { TextArea } from './components/TextArea';

export default TextArea;
